import './App.css';
import { useState } from 'react';

function App() {
  const [activeTab, setActiveTab] = useState('privacy');

  const currentDate = '2 décembre 2025';

  return (
    <div className="App">
      <header className="App-header">
        <div className="logo-container">
          <img src="/assets/Logo_Rankzone.png" className="App-logo" alt="RankZone logo" />
        </div>
        <h1>RankZone</h1>
        <nav className="nav-tabs">
          <button
            className={activeTab === 'privacy' ? 'active' : ''}
            onClick={() => setActiveTab('privacy')}
          >
            Politique de Confidentialité
          </button>
          <button
            className={activeTab === 'contact' ? 'active' : ''}
            onClick={() => setActiveTab('contact')}
          >
            Contact & Suppression
          </button>
          <button
            className={activeTab === 'legal' ? 'active' : ''}
            onClick={() => setActiveTab('legal')}
          >
            Mentions Légales
          </button>
        </nav>
        {activeTab === 'privacy' && <p className="update-date">Mise à jour : {currentDate}</p>}
      </header>

      <main className="App-content">
        <div className="content-container">
          {activeTab === 'privacy' && (
          <section className="privacy-section">
            <div className="intro-text">
              <p><strong>Merci d'utiliser RankZone.</strong></p>
              <p>Nous attachons une grande importance à la protection de vos données personnelles et au respect de votre vie privée.</p>
              <p>Cette Politique de Confidentialité explique quelles données nous collectons, pourquoi, comment elles sont utilisées, et vos droits.</p>
              <p>En utilisant RankZone, vous acceptez cette Politique.</p>
            </div>

            <div className="privacy-text">
              <h2>1. Qui sommes-nous ?</h2>
              <p>RankZone est une application mobile permettant de participer à des mini-jeux de compétences (skills games), accéder à des tournois payants avec classement, et gagner des récompenses lorsqu'on termine premier.</p>
              <div className="contact-info">
                <p><strong>Contact pour la vie privée :</strong></p>
                <p><a href="mailto:rankzone7@gmail.com">rankzone7@gmail.com</a></p>
              </div>

              <h2>2. Données personnelles que nous collectons</h2>
              <p>Nous collectons uniquement les informations nécessaires au fonctionnement de RankZone.</p>

              <h3>2.1. Informations fournies par l'utilisateur</h3>
              <ul>
                <li>Adresse e-mail</li>
                <li>Prénom et nom</li>
                <li>Numéro de téléphone</li>
                <li>Adresse, ville, État, code postal, pays</li>
                <li>Photo de profil (optionnelle)</li>
              </ul>
              <p>Ces informations sont utilisées pour le compte utilisateur, les paiements Stripe, les classements et les communications importantes.</p>

              <h2>3. Informations collectées automatiquement</h2>
              <h3>3.1. Données d'utilisation</h3>
              <p>Collectées via :</p>
              <ul>
                <li>Firebase</li>
                <li>Google Analytics</li>
              </ul>
              <p><strong>Exemples :</strong></p>
              <ul>
                <li>interactions dans l'app</li>
                <li>temps passé</li>
                <li>pages/écrans consultés</li>
                <li>modèle d'appareil, système d'exploitation</li>
                <li>adresse IP (anonymisée)</li>
                <li>identifiants techniques (ID Firebase)</li>
              </ul>
              <p>Ces données sont entièrement anonymisées.</p>

              <h3>3.2. Pas d'accès aux données sensibles</h3>
              <p>Nous ne collectons :</p>
              <ul>
                <li>ni GPS</li>
                <li>ni contacts</li>
                <li>ni photos</li>
                <li>ni caméra</li>
                <li>ni microphone</li>
              </ul>

              <h2>4. Paiements et transactions</h2>
              <p>Les paiements dans RankZone sont traités par :</p>
              <ul>
                <li><strong>Stripe</strong></li>
              </ul>
              <p>L'achat de tickets coûte 2,99 € ou 7,99 € pour un lot de 3.</p>
              <p>Nous ne stockons aucune donnée bancaire.</p>
              <p>Stripe traite vos informations selon sa propre politique :<br />
                <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">https://stripe.com/privacy</a>
              </p>
              <p>Les factures, paiements et litiges sont sécurisés via leur plateforme.</p>

              <h2>5. Emails et notifications</h2>
              <p>Nous envoyons des emails uniquement pour :</p>
              <ul>
                <li>confirmation de compte</li>
                <li>réinitialisation de mot de passe</li>
                <li>informations importantes</li>
                <li>résultats ou paiements liés aux tournois</li>
              </ul>
              <p><strong>Plateforme utilisée :</strong> Resend<br />
                Politique : <a href="https://resend.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">https://resend.com/legal/privacy-policy</a>
              </p>
              <p>Aucun email marketing automatisé n'est envoyé sans votre consentement.</p>

              <h2>6. Publicité</h2>
              <p>Nous n'affichons aucune publicité dans l'application.</p>
              <p>Aucun outil de remarketing n'est utilisé.</p>

              <h2>7. Réseaux sociaux</h2>
              <p>RankZone dispose d'une page Facebook officielle :<br />
                <a href="https://www.facebook.com/people/Rankzone/61582956002506/" target="_blank" rel="noopener noreferrer">https://www.facebook.com/people/Rankzone/61582956002506/</a>
              </p>
              <p>Aucune information n'est partagée automatiquement avec Facebook.</p>

              <h2>8. Base légale de la collecte (RGPD – Europe)</h2>
              <p>Nous collectons vos données conformément aux bases légales suivantes :</p>
              <ul>
                <li><strong>Exécution du contrat</strong> – fonctionnement du compte, achats, tournois.</li>
                <li><strong>Intérêt légitime</strong> – sécurité, prévention du spam, analytics.</li>
                <li><strong>Consentement</strong> – lorsque requis (notifications).</li>
              </ul>

              <h2>9. Partage des données</h2>
              <p>Nous partageons vos données uniquement avec des partenaires indispensables :</p>
              <ul>
                <li>Firebase (authentification, stockage)</li>
                <li>Google Analytics</li>
                <li>Stripe (paiements)</li>
                <li>Resend (e-mails)</li>
              </ul>
              <p><strong>Nous ne vendons jamais vos données.</strong></p>

              <h2>10. Conservation des données</h2>
              <p>Nous conservons les données :</p>
              <ul>
                <li>tant que votre compte est actif</li>
                <li>ou autant que nécessaire pour satisfaire les obligations légales.</li>
              </ul>
              <p>Vous pouvez demander la suppression à tout moment.</p>

              <h2>11. Sécurité</h2>
              <p>Nous utilisons :</p>
              <ul>
                <li>AppCheck Firebase</li>
                <li>Connexions chiffrées (HTTPS / TLS)</li>
                <li>Restrictions Firestore</li>
                <li>Protection contre les accès non autorisés</li>
              </ul>

              <h2>12. Vos droits (RGPD – utilisateurs européens)</h2>
              <p>Vous pouvez :</p>
              <ul>
                <li>demander une copie de vos données</li>
                <li>corriger vos informations</li>
                <li>demander l'effacement de votre compte</li>
                <li>refuser certains traitements</li>
                <li>demander la portabilité</li>
              </ul>
              <div className="contact-info">
                <p><strong>Contact :</strong> <a href="mailto:rankzone7@gmail.com">rankzone7@gmail.com</a></p>
              </div>

              <h2>13. Conformité</h2>

              <h3>13.1. RGPD (Europe)</h3>
              <p>RankZone est conforme au Règlement Général sur la Protection des Données (RGPD). Vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation, d'opposition et de portabilité de vos données personnelles.</p>

              <h3>13.2. CCPA / CPRA (Californie, États-Unis)</h3>
              <p>Pour les résidents de Californie : vous avez le droit de savoir quelles données personnelles sont collectées, de demander leur suppression et de refuser leur vente. RankZone ne vend jamais vos données personnelles.</p>

              <h3>13.3. CalOPPA (Californie)</h3>
              <p>Cette politique de confidentialité respecte les exigences du California Online Privacy Protection Act (CalOPPA). Nous nous engagons à notifier les utilisateurs de toute modification de cette politique.</p>

              <h3>13.4. COPPA (Protection des enfants)</h3>
              <p>RankZone est strictement réservé aux personnes de 18 ans et plus. Nous ne collectons volontairement aucune donnée d'enfants de moins de 13 ans. Si nous découvrons qu'un mineur a fourni des informations, nous supprimerons immédiatement ces données.</p>

              <h2>14. Modification de cette politique</h2>
              <p>Nous pouvons mettre à jour cette politique pour refléter :</p>
              <ul>
                <li>des changements dans l'application</li>
                <li>des obligations légales</li>
              </ul>
              <p>La date de mise à jour sera indiquée en haut de la page.</p>

              <h2>15. Contact</h2>
              <div className="contact-info">
                <p><strong>Pour toute question concernant la confidentialité :</strong></p>
                <p><a href="mailto:rankzone7@gmail.com">rankzone7@gmail.com</a></p>
              </div>
            </div>
          </section>
          )}

          {activeTab === 'contact' && (
          <section className="contact-section">
            <h2>Contact & Suppression de Compte</h2>

            <div className="contact-block">
              <h3>Nous Contacter</h3>
              <p>Pour toute question concernant vos données personnelles, votre compte RankZone, ou cette politique de confidentialité, vous pouvez nous contacter à :</p>
              <div className="contact-info">
                <p><strong>Email :</strong> <a href="mailto:rankzone7@gmail.com">rankzone7@gmail.com</a></p>
              </div>
            </div>

            <div className="deletion-block">
              <h3>Suppression de Compte et Données</h3>
              <p>Conformément au RGPD et aux exigences de Google Play Store, vous avez le droit de demander la suppression de votre compte RankZone et de toutes les données personnelles associées.</p>

              <h4>Procédure de Suppression</h4>
              <ol>
                <li>Envoyez un email à <a href="mailto:rankzone7@gmail.com">rankzone7@gmail.com</a></li>
                <li>Utilisez comme objet : "Demande de suppression de compte RankZone"</li>
                <li>Indiquez l'adresse email associée à votre compte</li>
                <li>Nous traiterons votre demande sous 30 jours maximum</li>
              </ol>

              <h4>Données Supprimées</h4>
              <p>Lors de la suppression de votre compte, les données suivantes seront définitivement effacées :</p>
              <ul>
                <li>Informations de profil (nom, prénom, email, téléphone)</li>
                <li>Adresse et informations de localisation</li>
                <li>Historique de jeux et tournois</li>
                <li>Préférences et paramètres</li>
              </ul>

              <h4>Données Conservées Temporairement</h4>
              <p>Pour des raisons légales, comptables et de sécurité, certaines données peuvent être conservées pendant une durée limitée :</p>
              <ul>
                <li><strong>Données de paiement et factures</strong> : conservées 10 ans (obligation légale française)</li>
                <li><strong>Données de prévention de fraude</strong> : conservées 3 ans maximum</li>
                <li><strong>Logs de sécurité anonymisés</strong> : conservés 1 an maximum</li>
              </ul>
              <p>Ces données sont stockées de manière sécurisée et ne sont plus utilisées à des fins opérationnelles.</p>

              <h4>Important</h4>
              <div className="warning-box">
                <p>⚠️ La suppression de votre compte est <strong>irréversible</strong>. Toutes vos données, votre progression, vos statistiques et votre solde seront définitivement perdus.</p>
                <p>Assurez-vous d'avoir récupéré toutes les informations importantes avant de procéder.</p>
              </div>
            </div>
          </section>
          )}

          {activeTab === 'legal' && (
          <section className="legal-section">
            <div className="intro-text">
              <p>En créant un compte sur RANKZONE, vous acceptez nos conditions d'utilisation et notre politique de confidentialité.</p>
            </div>

            <div className="privacy-text">
              <h2>Éditeur de l'application</h2>
              <ul>
                <li><strong>Nom de l'entreprise :</strong> Rankzone</li>
                <li><strong>Statut :</strong> Micro-entreprise</li>
                <li><strong>Nom du représentant légal :</strong> Alexis Meuret</li>
                <li><strong>Développeur de l'application :</strong> Médy Daniel</li>
                <li><strong>SIRET :</strong> 989 853 718</li>
                <li><strong>Email de contact :</strong> <a href="mailto:rankzone7@gmail.com">rankzone7@gmail.com</a></li>
              </ul>

              <h2>Hébergement de l'application</h2>
              <h3>Hébergeur back-end (Firebase) :</h3>
              <p>Google Firebase – Google Cloud Platform<br />
              1600 Amphitheatre Parkway, Mountain View, CA 94043, États-Unis<br />
              <a href="https://firebase.google.com" target="_blank" rel="noopener noreferrer">https://firebase.google.com</a></p>

              <h3>Hébergement front/app :</h3>
              <p>Play Store (Google LLC) / App Store (Apple Inc.)</p>

              <h2>Propriété intellectuelle</h2>
              <p>L'ensemble du contenu de l'application Rankzone (textes, images, logos, illustrations, jeux, design, interface, code) est la propriété exclusive de son éditeur, sauf mention contraire.</p>
              <p>Toute reproduction, représentation, modification ou exploitation partielle ou totale est strictement interdite sans l'autorisation écrite de l'éditeur.</p>

              <h2>Conditions d'utilisation</h2>
              <p>L'utilisation de l'application Rankzone implique l'acceptation pleine et entière des Conditions Générales d'Utilisation (CGU), accessibles depuis l'application et le site officiel.</p>
              <p>L'application est réservée aux personnes âgées de minimum 18 ans.</p>
              <p>Les concours sont basés sur la performance (skill) et ne relèvent en aucun cas du hasard ou de la loterie, conformément à la législation française et européenne.</p>

              <h3>Limite de participation</h3>
              <p>Chaque tournoi ouvert limite la participation à 4 tentatives maximum par jeu. Au-delà de cette limite, aucune partie supplémentaire ne peut être comptabilisée pour le classement.</p>

              <h2>Données personnelles & RGPD</h2>
              <p>Conformément au Règlement Général sur la Protection des Données (RGPD), les données collectées (nom, email, identifiants, statistiques de jeu…) sont utilisées uniquement dans le cadre du fonctionnement de l'application et de l'organisation des concours.</p>
              <p><strong>Responsable du traitement :</strong> Alexis Meuret<br />
              <strong>Délégué à la protection des données.</strong><br />
              <strong>Durée de conservation :</strong> 3 ans maximum après inactivité.</p>
              <p>Vous pouvez exercer vos droits (accès, rectification, suppression, opposition) en écrivant à : <a href="mailto:rankzone7@gmail.com">rankzone7@gmail.com</a></p>

              <h2>Paiements et sécurité</h2>
              <p>Les paiements dans l'application sont réalisés via un prestataire tiers sécurisé : Stripe.</p>
              <p>Aucune donnée bancaire n'est stockée sur les serveurs de Rankzone.</p>

              <h2>Responsabilité</h2>
              <p>L'éditeur s'efforce de fournir un service stable et sécurisé, mais ne pourra être tenu responsable en cas de :</p>
              <ul>
                <li>Dysfonctionnement de l'application (bugs, lenteurs, coupures)</li>
                <li>Pertes de données</li>
                <li>Utilisation frauduleuse de l'application par des tiers</li>
              </ul>

              <h2>Modifications des mentions légales</h2>
              <p>L'éditeur se réserve le droit de modifier les présentes mentions légales à tout moment.</p>
              <p>Les utilisateurs seront informés en cas de changement majeur.</p>

              <h2>Droit applicable</h2>
              <p>Les présentes mentions sont régies par le droit français.</p>
              <p>En cas de litige, et à défaut de résolution amiable, les tribunaux compétents seront ceux du ressort du siège de l'éditeur.</p>

              <h2>Accessibilité</h2>
              <p>L'éditeur s'engage à rendre l'application Rankzone accessible à tous les utilisateurs.</p>
              <p>Des mises à jour pourront être apportées pour améliorer l'ergonomie, la compatibilité et la fluidité sur différents appareils (iOS, Android).</p>
              <p>Pour tout signalement d'un problème d'accessibilité : <a href="mailto:rankzone7@gmail.com">rankzone7@gmail.com</a></p>

              <h2>Service client</h2>
              <p>Pour toute question, réclamation ou demande d'assistance concernant Rankzone, les utilisateurs peuvent contacter le support client à l'adresse suivante :</p>
              <p><a href="mailto:rankzone7@gmail.com">rankzone7@gmail.com</a></p>
              <p>Un retour sera fait sous 72h maximum.</p>

              <h2>Clause de non-affiliation</h2>
              <p>Rankzone n'est en aucun cas affiliée, sponsorisée ou approuvée par les marques citées dans les concours ou comme exemples de lots (Apple, Sony, Boulanger, etc.).</p>
              <p>Tous les noms de marques, logos ou produits sont la propriété de leurs détenteurs respectifs.</p>

              <h2>Conditions Générales d'Utilisation</h2>

              <h3>1. Objet</h3>
              <p>Les présentes Conditions Générales d'Utilisation (CGU) définissent les règles d'accès et d'utilisation de l'application mobile Rankzone, éditée par Rankzone (micro-entreprise).</p>
              <p>En utilisant l'application, vous acceptez sans réserve les présentes CGU.</p>

              <h3>2. Accès à l'application</h3>
              <p>L'application Rankzone est accessible gratuitement sur iOS et Android via l'App Store et le Play Store.</p>
              <p><strong>Conditions d'accès :</strong></p>
              <ul>
                <li>Âge minimum : 18 ans révolus</li>
                <li>Création d'un compte utilisateur (email + mot de passe)</li>
                <li>Acceptation des CGU et de la politique de confidentialité</li>
              </ul>
              <p>L'accès à l'application nécessite une connexion Internet. Les frais liés à cette connexion sont à la charge de l'utilisateur.</p>

              <h3>2 bis. Conditions d'âge et fausse déclaration</h3>
              <p><strong>Accès à l'application :</strong> L'application Rankzone est strictement réservée aux personnes âgées de 18 ans ou plus au moment de leur inscription. En accédant à l'application et en créant un compte, l'utilisateur certifie sur l'honneur être âgé d'au moins 18 ans révolus.</p>
              <p><strong>Fausse déclaration d'âge :</strong> Toute inscription réalisée sous une fausse déclaration d'âge constitue une infraction aux présentes CGU. En cas de fausse déclaration, la responsabilité de l'éditeur ne saurait être engagée. Le participant reconnaît qu'il engage sa propre responsabilité ou celle de son représentant légal.</p>
              <p><strong>Livraison des lots :</strong> Si un joueur ne respecte pas la condition d'âge ou ne peut fournir la preuve de majorité, le lot sera considéré comme nul et non attribué, sans compensation possible.</p>
              <p><strong>Responsabilité de l'utilisateur :</strong> L'éditeur de Rankzone ne saurait être tenu responsable de l'accès frauduleux d'un mineur à l'application via une fausse déclaration, un compte partagé ou un moyen de paiement parental non autorisé. La vérification de l'âge repose sur la déclaration de bonne foi de l'utilisateur.</p>

              <h3>3. Inscription et compte utilisateur</h3>
              <p>Pour participer aux tournois, vous devez créer un compte avec :</p>
              <ul>
                <li>Un nom d'utilisateur unique</li>
                <li>Une adresse email valide</li>
                <li>Un mot de passe sécurisé (8 caractères minimum)</li>
              </ul>
              <p>Vous êtes responsable de la confidentialité de vos identifiants.</p>
              <p>Toute utilisation frauduleuse de votre compte doit être signalée immédiatement à <a href="mailto:rankzone7@gmail.com">rankzone7@gmail.com</a>.</p>

              <h3>4. Utilisation de l'application</h3>
              <p>Vous vous engagez à :</p>
              <ul>
                <li>Utiliser l'application de manière loyale et conforme à sa destination</li>
                <li>Ne pas utiliser de logiciels, scripts ou robots pour tricher</li>
                <li>Ne pas tenter de pirater, modifier ou altérer le fonctionnement de l'application</li>
                <li>Respecter les autres utilisateurs (pas de contenu offensant, injurieux ou illégal)</li>
              </ul>
              <p>Toute violation de ces règles peut entraîner :</p>
              <ul>
                <li>La suspension ou suppression du compte</li>
                <li>L'annulation des gains</li>
                <li>Des poursuites judiciaires en cas d'infraction grave</li>
              </ul>

              <h3>5. Propriété intellectuelle</h3>
              <p>Tous les éléments de l'application (design, jeux, textes, logos, code source) sont la propriété exclusive de Rankzone.</p>
              <p>Toute reproduction, modification ou exploitation non autorisée est interdite et passible de sanctions.</p>

              <h3>6. Disponibilité de l'application</h3>
              <p>Rankzone s'efforce d'assurer une disponibilité maximale de l'application, mais ne garantit pas :</p>
              <ul>
                <li>Une absence totale de bugs ou d'erreurs</li>
                <li>Un fonctionnement ininterrompu (mises à jour, maintenance)</li>
                <li>Une compatibilité avec tous les appareils</li>
              </ul>
              <p>L'éditeur ne pourra être tenu responsable en cas d'indisponibilité temporaire.</p>

              <h3>7. Modification des CGU</h3>
              <p>Rankzone se réserve le droit de modifier les présentes CGU à tout moment.</p>
              <p>Les utilisateurs seront informés par notification dans l'application ou par email.</p>
              <p>La poursuite de l'utilisation après modification vaut acceptation des nouvelles CGU.</p>

              <h3>8. Résiliation</h3>
              <p>Vous pouvez supprimer votre compte à tout moment depuis les Paramètres de l'application.</p>
              <p>Rankzone se réserve le droit de suspendre ou supprimer un compte en cas de :</p>
              <ul>
                <li>Violation des CGU</li>
                <li>Activité suspecte ou frauduleuse</li>
                <li>Non-respect du règlement des tournois</li>
              </ul>

              <h3>9. Protection des données personnelles</h3>
              <p>Vos données personnelles sont traitées conformément au RGPD.</p>
              <p>Pour plus d'informations, consultez la section "Politique de Confidentialité".</p>

              <h3>10. Droit applicable et juridiction</h3>
              <p>Les présentes CGU sont régies par le droit français.</p>
              <p>En cas de litige, une solution amiable sera recherchée en priorité. À défaut, les tribunaux français seront compétents.</p>

              <h2>Conditions Générales de Vente (CGV)</h2>

              <h3>1. Objet</h3>
              <p>Les présentes Conditions Générales de Vente (CGV) régissent l'achat de tickets de participation aux tournois via l'application Rankzone.</p>
              <p>Tout achat implique l'acceptation des présentes CGV.</p>

              <h3>2. Produits proposés</h3>
              <p>L'application propose l'achat de tickets de participation :</p>
              <ul>
                <li>1 ticket : 2,99 €</li>
                <li>Pack de 3 tickets : 7,99 €</li>
              </ul>
              <p>Les tickets permettent de participer aux tournois hebdomadaires avec des lots à gagner (produits physiques).</p>

              <h3>3. Prix</h3>
              <p>Les prix sont affichés en euros (€), toutes taxes comprises (TTC).</p>
              <p>Rankzone se réserve le droit de modifier les prix à tout moment, mais les achats déjà effectués restent au prix indiqué lors de la transaction.</p>

              <h3>4. Paiement</h3>
              <p>Les paiements sont sécurisés et gérés par un prestataire tiers certifié : Stripe (cartes bancaires).</p>
              <p>Aucune donnée bancaire n'est stockée sur les serveurs de Rankzone.</p>
              <p>Le paiement est immédiat et les tickets sont crédités instantanément sur votre compte (délai maximum : 10 secondes).</p>

              <h3>5. Droit de rétractation</h3>
              <p>Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation ne s'applique PAS aux contenus numériques fournis immédiatement après achat avec accord préalable du consommateur.</p>
              <p>En achetant des tickets, vous acceptez leur fourniture immédiate et renoncez à votre droit de rétractation de 14 jours.</p>
              <p>Aucun remboursement ne sera accordé une fois les tickets crédités, sauf :</p>
              <ul>
                <li>Erreur technique avérée (double débit sans double crédit)</li>
                <li>Non-conformité du service</li>
              </ul>
              <p>Pour toute réclamation : <a href="mailto:rankzone7@gmail.com">rankzone7@gmail.com</a> (réponse sous 72h).</p>

              <h3>6. Utilisation des tickets</h3>
              <p>Les tickets achetés :</p>
              <ul>
                <li>Sont valables indéfiniment (pas de date d'expiration)</li>
                <li>Sont liés à votre compte utilisateur (non transférables)</li>
                <li>Permettent de participer aux tournois avec une limite de 4 participations maximum par tournoi ouvert et par jeu</li>
                <li>Ne peuvent pas être convertis en argent</li>
              </ul>
              <p>En cas de suppression de compte, les tickets non utilisés sont définitivement perdus (aucun remboursement).</p>

              <h3>7. Garanties</h3>
              <p>Rankzone garantit :</p>
              <ul>
                <li>Le crédit immédiat des tickets après paiement validé</li>
                <li>La possibilité de participer aux tournois conformément au règlement</li>
                <li>La livraison des lots physiques en cas de victoire</li>
              </ul>
              <p>En cas de problème technique empêchant l'utilisation d'un ticket payé, Rankzone s'engage à créditer un ticket de remplacement ou à rembourser le montant correspondant.</p>

              <h3>8. Responsabilité</h3>
              <p>Rankzone ne pourra être tenu responsable en cas de :</p>
              <ul>
                <li>Perte de tickets suite à la suppression volontaire de votre compte</li>
                <li>Utilisation frauduleuse de votre compte par un tiers (si négligence de votre part)</li>
                <li>Indisponibilité temporaire de l'application (maintenance, bugs)</li>
                <li>Force majeure (panne serveur, cyberattaque, catastrophe naturelle)</li>
              </ul>

              <h3>9. Remboursements exceptionnels</h3>
              <p>Un remboursement pourra être accordé uniquement dans les cas suivants :</p>
              <ul>
                <li>Double débit sans double crédit de tickets</li>
                <li>Bug technique avéré empêchant l'utilisation des tickets</li>
                <li>Annulation définitive d'un tournoi sans replacement</li>
              </ul>
              <p>Pour demander un remboursement, contactez <a href="mailto:rankzone7@gmail.com">rankzone7@gmail.com</a> avec :</p>
              <ul>
                <li>Votre email de compte</li>
                <li>La date et le montant de la transaction</li>
                <li>Une description détaillée du problème</li>
              </ul>
              <p>Les remboursements sont traités sous 7 jours ouvrés.</p>

              <h3>10. Facturation</h3>
              <p>Les reçus de paiement sont envoyés automatiquement par email après chaque achat.</p>
              <p>Pour obtenir une facture détaillée, contactez <a href="mailto:rankzone7@gmail.com">rankzone7@gmail.com</a>.</p>

              <h3>11. Médiation et réclamation</h3>
              <p>En cas de litige, vous pouvez contacter notre service client : <a href="mailto:rankzone7@gmail.com">rankzone7@gmail.com</a></p>
              <p>Si aucune solution amiable n'est trouvée, vous pouvez saisir le médiateur de la consommation :</p>
              <p>CM2C - Médiateur de la consommation<br />
              14 rue Saint Jean - 75017 Paris<br />
              <a href="https://www.cm2c.fr" target="_blank" rel="noopener noreferrer">https://www.cm2c.fr</a></p>

              <h3>12. Droit applicable</h3>
              <p>Les présentes CGV sont régies par le droit français.</p>
              <p>Les tribunaux français sont seuls compétents en cas de litige.</p>

              <h2>Règlement officiel des tournois Rankzone</h2>

              <h3>1. Organisateur</h3>
              <p>Les tournois Rankzone sont organisés par :</p>
              <ul>
                <li>Rankzone - Micro-entreprise</li>
                <li>SIRET : 989 853 718</li>
                <li>Représentant légal : Alexis Meuret</li>
                <li>Email : <a href="mailto:rankzone7@gmail.com">rankzone7@gmail.com</a></li>
              </ul>

              <h3>2. Principe des tournois</h3>
              <p>Les tournois Rankzone sont des compétitions de skill (adresse et réflexes) organisées hebdomadairement.</p>
              <p>Aucun élément de hasard n'intervient dans les résultats : seule la performance du joueur détermine le classement.</p>
              <p><strong>Conformité légale :</strong></p>
              <ul>
                <li>Ne relève PAS de la loi sur les jeux de hasard</li>
                <li>Ne nécessite PAS d'agrément de l'ANJ (Autorité Nationale des Jeux)</li>
                <li>Conforme à la législation française et européenne sur les compétitions de skill</li>
              </ul>

              <h3>3. Conditions de participation</h3>
              <p>Pour participer aux tournois, vous devez :</p>
              <ul>
                <li>Avoir 18 ans révolus</li>
                <li>Posséder un compte Rankzone vérifié</li>
                <li>Acheter au moins 1 ticket de participation (2,99 €)</li>
                <li>Renseigner une adresse de livraison valide en France métropolitaine</li>
                <li>Accepter le présent règlement</li>
              </ul>
              <p><strong>Limite :</strong> 4 participations maximum par tournoi ouvert et par jeu.</p>

              <h3>3 bis. Conditions d'âge et fausse déclaration</h3>
              <p><strong>Accès :</strong> L'application est strictement réservée aux personnes âgées de 18 ans ou plus. L'utilisateur certifie sur l'honneur sa majorité lors de l'inscription.</p>
              <p><strong>Fausse déclaration :</strong> Toute inscription sous fausse déclaration d'âge viole le présent règlement. La responsabilité de l'éditeur ne peut être engagée ; le participant engage la sienne (ou celle de son représentant légal).</p>
              <p><strong>Livraison des lots :</strong> En absence de preuve de majorité, le lot est nul et non attribué, sans compensation.</p>
              <p><strong>Responsabilité :</strong> L'éditeur n'est pas responsable d'un accès frauduleux d'un mineur (fausse déclaration, compte partagé, paiement parental non autorisé). La vérification repose sur la déclaration de bonne foi de l'utilisateur.</p>

              <h3>4. Déroulement des tournois</h3>
              <p><strong>Période de jeu :</strong> Du lundi 00h00 au dimanche 23h59 (heure de Paris). Cela peut varier et être modifié à l'avenir.</p>
              <p><strong>Fonctionnement :</strong></p>
              <ul>
                <li>Chaque participation consomme 1 ticket</li>
                <li>Vous jouez une partie sur le mini-jeu sélectionné</li>
                <li>Votre meilleur score de la semaine est conservé au classement</li>
                <li>À la fin du tournoi, le meilleur joueur remporte le lot</li>
              </ul>
              <p>Les scores sont validés par un système anti-triche automatique.</p>

              <h3>5. Lots à gagner</h3>
              <p>Chaque tournoi hebdomadaire propose un lot physique neuf pour le gagnant (valeur indicative) :</p>
              <p><strong>1er prix :</strong> Lot premium (ex : iPhone, console, trottinette électrique, AirPods Max, etc.)</p>
              <p>Le lot est annoncé dans l'application avant chaque tournoi.</p>
              <p>Le lot ne peut pas être :</p>
              <ul>
                <li>Échangé contre de l'argent</li>
                <li>Échangé contre un autre produit</li>
                <li>Transféré à une autre personne</li>
              </ul>

              <h3>6. Désignation du gagnant</h3>
              <p>Le gagnant est déterminé automatiquement le dimanche à 23h59 :</p>
              <p>Le joueur avec le meilleur score de la semaine remporte le lot.</p>
              <p><strong>En cas d'égalité parfaite :</strong> Le joueur ayant soumis le score en premier est prioritaire.</p>
              <p>Le gagnant est notifié par email et notification dans l'application sous 48h.</p>

              <h3>7. Livraison du lot</h3>
              <p>Le gagnant reçoit son lot par voie postale :</p>
              <ul>
                <li>Délai : 7 à 14 jours ouvrés après validation de l'adresse</li>
                <li>Zone : France métropolitaine uniquement</li>
                <li>Transporteur : Colissimo ou Chronopost (selon la valeur)</li>
                <li>Suivi : Numéro de tracking envoyé par email</li>
              </ul>
              <p>Le gagnant doit :</p>
              <ul>
                <li>Confirmer son adresse de livraison sous 7 jours</li>
                <li>Être présent pour réceptionner le colis (ou autoriser un dépôt)</li>
              </ul>
              <p>En cas d'absence de réponse sous 30 jours, le lot est perdu définitivement.</p>

              <h3>8. Exclusions et sanctions</h3>
              <p>Ne peuvent pas participer :</p>
              <ul>
                <li>Les employés de Rankzone et leurs familles proches</li>
                <li>Les personnes utilisant des logiciels de triche</li>
                <li>Les comptes multiples d'une même personne</li>
              </ul>
              <p>En cas de triche détectée :</p>
              <ul>
                <li>Disqualification immédiate</li>
                <li>Suppression du compte</li>
                <li>Interdiction définitive de participer</li>
                <li>Annulation du lot (si déjà gagné)</li>
                <li>Poursuites judiciaires possibles en cas de fraude avérée</li>
              </ul>

              <h3>9. Anti-triche</h3>
              <p>Rankzone met en œuvre des systèmes anti-triche :</p>
              <ul>
                <li>Validation automatique des scores (seuils maximums)</li>
                <li>Détection de patterns suspects</li>
                <li>Vérification manuelle des top 3 avant envoi des lots</li>
              </ul>
              <p>Tout score jugé impossible ou frauduleux sera rejeté, même après validation initiale.</p>

              <h3>10. Réclamations</h3>
              <p>Pour toute réclamation concernant un tournoi :</p>
              <ul>
                <li>Contactez <a href="mailto:rankzone7@gmail.com">rankzone7@gmail.com</a> dans les 7 jours suivant la fin du tournoi</li>
                <li>Indiquez : votre pseudo, le jeu concerné, et la nature de la réclamation</li>
                <li>Réponse sous 72h maximum</li>
              </ul>
              <p>Les décisions de Rankzone sont définitives et sans appel.</p>

              <h3>11. Modification du règlement</h3>
              <p>Rankzone se réserve le droit de modifier le règlement à tout moment.</p>
              <p>Les modifications seront notifiées dans l'application.</p>
              <p>Les tournois en cours restent soumis au règlement en vigueur au moment de leur lancement.</p>

              <h3>12. Responsabilité</h3>
              <p>Rankzone ne pourra être tenu responsable en cas de :</p>
              <ul>
                <li>Bug technique empêchant la participation (ticket remboursé)</li>
                <li>Annulation d'un tournoi (tickets remboursés ou report)</li>
                <li>Perte ou vol du colis après expédition (assurance transporteur)</li>
                <li>Dommages causés par une utilisation inappropriée du lot reçu</li>
              </ul>

              <h3>13. Droit à l'image</h3>
              <p>En participant, vous autorisez Rankzone à :</p>
              <ul>
                <li>Afficher votre pseudo dans le classement public</li>
                <li>Annoncer les gagnants (pseudo uniquement, pas de nom réel)</li>
                <li>Publier des captures d'écran du classement sur les réseaux sociaux</li>
              </ul>
              <p>Votre adresse et informations personnelles restent strictement confidentielles.</p>

              <h3>14. Droit applicable</h3>
              <p>Le présent règlement est régi par le droit français.</p>
              <p>En cas de litige, une solution amiable sera recherchée en priorité.</p>
              <p>À défaut, les tribunaux français seront compétents.</p>
            </div>
          </section>
          )}
        </div>
      </main>

      <footer className="App-footer">
        <div className="footer-links">
          <a href="https://www.facebook.com/people/Rankzone/61582956002506/" target="_blank" rel="noopener noreferrer">Facebook</a>
          <a href="mailto:rankzone7@gmail.com">Contact</a>
        </div>
        <p className="copyright">&copy; {new Date().getFullYear()} RankZone - Tous droits réservés</p>
      </footer>
    </div>
  );
}

export default App;
